// extracted by mini-css-extract-plugin
export default {"container":"ProgressNote_container__fAcn6"};